import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button";

import { ReactComponent as AppstoreLogo } from "../../assets/img/Download_on_the_App_Store_Badge_DE_RGB_blk_092917.svg";

import modalStyle from "assets/jss/material-kit-pro-react/modalStyle";

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props, ref) => (
	<Slide direction="down" ref={ref} {...props} />
));

const InstallAppDialog = ({ classes }) => {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		const hideInstallDialog = sessionStorage.getItem("hideInstallDialog");
		if (!hideInstallDialog) setTimeout(() => setOpen(true), 5000);
	}, []);

	const handleClose = () => {
		sessionStorage.setItem("hideInstallDialog", true);
		setOpen(false);
	};

	return (
		<div>
			{open && (
				<Dialog
					classes={{
						root: classes.modalRoot,
						paper: classes.modal,
					}}
					open={open}
					TransitionComponent={Transition}
					keepMounted
					onClose={() => handleClose()}
					aria-labelledby="classic-modal-slide-title"
					aria-describedby="classic-modal-slide-description"
					disableEscapeKeyDown
					disableBackdropClick
				>
					<DialogTitle
						id="classic-modal-slide-title"
						disableTypography
						className={classes.modalHeader}
					>
						<Button
							simple
							className={classes.modalCloseButton}
							key="close"
							aria-label="Close"
							onClick={() => handleClose()}
						>
							{" "}
							<Close className={classes.modalClose} />
						</Button>
						<h4 className={classes.modalTitle}>
							Die App gibt's auch im Store!
						</h4>
					</DialogTitle>
					<DialogContent
						id="classic-modal-slide-description"
						className={classes.modalBody}
					>
						Hol dir jetzt die Sportapp im App oder Playstore!
					</DialogContent>
					<DialogActions className={classes.modalFooter}>
						<a href="http://play.google.com/store/apps/details?id=de.codecentric.labs.solingersportbund&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
							<img
								style={{
									width: 130,
								}}
								alt="Jetzt bei Google Play"
								src="https://play.google.com/intl/en_us/badges/static/images/badges/de_badge_web_generic.png"
							/>
						</a>
						<a
							href="https://apps.apple.com/us/app/solingen-sportapp/id1459788664"
							style={{ marginTop: "auto" }}
						>
							<AppstoreLogo />
						</a>
						<Button
							color="primary"
							onClick={() => {
								handleClose();
							}}
						>
							Vielleicht später
						</Button>
					</DialogActions>
				</Dialog>
			)}
		</div>
	);
};

InstallAppDialog.propTypes = {
	classes: PropTypes.object,
};

export default withStyles(modalStyle)(InstallAppDialog);
